import { ServiceRequestErrorState } from "./ServiceRequestError.types";

export const serviceRequestErrorStateDefault: ServiceRequestErrorState = {
  errors: [],
  hasErrors: false,
  setErrors: () => null,
};
